const es = {
  nav: {
    home:          'Inicio',
    myOrder:       'Mi Pedido',
    history:       'Historial',
    admin:         'Administración',
    signOut:       'Cerrar sesión',
    administrator: 'Administrador',
    user:          'Usuario',
    manages:       'Administra',
    personal:      'Personal',
  },
  common: {
    restaurant:    'Restaurante',
    menu:          'Menú',
    price:         'Precio',
    status:        'Estado',
    date:          'Fecha',
    user:          'Usuario',
    email:         'Email',
    name:          'Nombre',
    description:   'Descripción',
    imageUrl:      'URL de imagen',
    country:       'País',
    argentina:     'Argentina',
    chile:         'Chile',
    colombia:      'Colombia',
    allCountries:  'Todos los países',
    cancel:        'Cancelar',
    save:          'Guardar',
    create:        'Crear',
    edit:          'Editar',
    delete:        'Eliminar',
    add:           'Agregar',
    update:        'Actualizar',
    confirm:       'Confirmar',
    close:         'Cerrar',
    back:          'Volver',
    exportExcel:   'Exportar a Excel',
    active:        'Activo',
    cancelled:     'Cancelado',
    inactive:      'Inactivo',
    celiac:        'Opción celíaca',
    yes:           'Sí',
    no:            'No',
    notes:         'Notas',
    category:      'Categoría',
    whatsapp:      'WhatsApp',
    orderDate:     'Fecha de Pedido',
    dish:          'Plato',
    total:         'Total',
    role:          'Rol',
    month:         'Mes',
    year:          'Año',
  },
  dashboard: {
    welcome:                  'Bienvenido, {{name}}!',
    subtitle:                 'Seleccioná tu almuerzo para hoy',
    ordersOpen:               'Pedidos Abiertos',
    ordersClosed:             'Pedidos Cerrados',
    ordersOpenDesc:           'Podés realizar o modificar tu pedido de 8:00 AM a 6:00 PM',
    ordersClosedHours:        'Los pedidos están disponibles de 8:00 AM a 6:00 PM',
    ordersClosedDay:          'Los pedidos para hoy ya están cerrados. Volvé mañana!',
    myOrdersToday:            'Tus Pedidos de Hoy',
    myOrderToday:             'Tu Pedido de Hoy',
    selectRestaurant:         'Seleccioná un Restaurante',
    selectRestaurantPh:       '-- Seleccioná un restaurante --',
    selectMenu:               'Seleccioná un Menú',
    noMenus:                  'No hay menús disponibles para este restaurante',
    addOrder:                 'Agregar Pedido',
    confirmOrder:             'Confirmar Pedido',
    updateOrder:              'Actualizar Pedido',
    modifyOrder:              'Modificar Pedido',
    cancelOrder:              'Cancelar Pedido',
    closedTitle:              'Pedidos Cerrados',
    closedDesc:               'Los pedidos para hoy ya están cerrados. Volvé mañana para hacer tu pedido.',
    cancelConfirm:            '¿Estás seguro de que deseas cancelar este pedido?',
    errorSelect:              'Por favor selecciona un restaurante y un menú',
    successAdd:               '¡Pedido agregado exitosamente!',
    successUpdate:            '¡Pedido actualizado exitosamente!',
    successCreate:            '¡Pedido creado exitosamente!',
    successCancel:            'Pedido cancelado exitosamente',
    errorLoad:                'Error al cargar datos',
    errorOrder:               'Error al procesar el pedido',
    errorCancel:              'Error al cancelar el pedido',
    errorMenuItems:           'Error al cargar los menús',
  },
  history: {
    title:         'Historial de Pedidos',
    subtitle:      'Revisá tus pedidos anteriores',
    empty:         'No hay pedidos en el historial',
    emptyDesc:     'Tus pedidos anteriores aparecerán aquí',
    today:         'Hoy',
    order_one:     '{{count}} pedido',
    order_other:   '{{count}} pedidos',
    totalDay:      'Total del día:',
    errorLoad:     'Error cargando historial',
  },
  admin: {
    title:              'Panel de Administración',
    subtitle:           'Gestioná restaurantes, menús y pedidos',
    tabToday:           'Almuerzo de Hoy',
    tabRestaurants:     'Restaurantes',
    tabUsers:           'Usuarios',
    tabReports:         'Reportes',
    // Today
    noLunch:            'No hay almuerzo programado para hoy',
    noLunchDesc:        'Los almuerzos se gestionan automáticamente cuando los usuarios hacen sus pedidos.',
    noLunchNote:        'El almuerzo del día se crea automáticamente cuando el primer usuario realiza un pedido.',
    totalOrders:        'Total Pedidos',
    diners:             'Comensales',
    totalAmount:        'Monto Total',
    restaurants:        'Restaurantes',
    manualEntry:        'Carga Manual',
    manualEntryDetails: 'Detalles de Carga Manual',
    registeredBy:       'Registrado por',
    closeLunch:         'Cerrar Almuerzo',
    reopenLunch:        'Reabrir Almuerzo',
    closeManual:        'Cerrar con Carga Manual',
    closeLunchConfirm:  '¿Estás seguro de que deseas cerrar el almuerzo de hoy?',
    reopenLunchConfirm: '¿Estás seguro de que deseas reabrir el almuerzo de hoy?',
    whatsappOrder:      'Pedir por WhatsApp',
    cancelOrder:        'Cancelar Pedido',
    cancelOrderConfirm: '¿Estás seguro de que deseas cancelar el pedido de {{name}}?',
    // Restaurants
    addRestaurant:      'Agregar Restaurante',
    editRestaurant:     'Editar Restaurante',
    restaurantName:     'Nombre del restaurante',
    isDefault:          'Restaurante por defecto',
    viewMenu:           'Ver Menú',
    noRestaurants:      'No hay restaurantes registrados',
    deleteRestaurantConfirm: '¿Estás seguro de eliminar este restaurante?',
    // Menu items
    menuOf:             'Menú de {{name}}',
    addDish:            'Agregar Plato',
    editDish:           'Editar Plato',
    dishName:           'Nombre del plato',
    isCeliac:           'Es opción celíaca',
    noMenuItems:        'No hay platos registrados',
    deleteDishConfirm:  '¿Estás seguro de eliminar este plato?',
    // Users
    addUser:            'Agregar Usuario',
    noUsers:            'No hay usuarios registrados',
    changeRole:         'Cambiar Rol',
    resetPassword:      'Resetear Contraseña',
    disable:            'Deshabilitar',
    enable:             'Habilitar',
    deleteUser:         'Eliminar',
    disableConfirm:     '¿Estás seguro de deshabilitar a {{email}}?',
    enableConfirm:      '¿Estás seguro de habilitar a {{email}}?',
    resetConfirm:       '¿Estás seguro de resetear la contraseña de {{email}}?',
    deleteUserConfirm:  '¿Estás seguro de eliminar permanentemente a {{email}}? Esta acción no se puede deshacer.',
    tempPassword:       'Contraseña temporal',
    copyPassword:       'Copiar',
    copied:             '¡Copiado!',
    // Reports
    reportByUser:       'Pedidos por Usuario',
    topUsers:           'TOP 10 Usuarios',
    topRestaurants:     'TOP 10 Restaurantes',
    topDishes:          'TOP 10 Platos',
    selectUser:         'Seleccioná un usuario',
    generate:           'Generar',
    dateRange:          'Rango de fechas',
    byMonth:            'Por mes',
    customRange:        'Rango personalizado',
    startDate:          'Fecha inicio',
    endDate:            'Fecha fin',
    ordersCount:        'Pedidos',
    noResults:          'Sin resultados',
    // Manual close
    manualRestaurantName: 'Nombre del restaurante',
    manualDiners:         'Cantidad de comensales',
    manualAmount:         'Monto total',
    manualNotes:          'Notas (opcional)',
    confirmManualClose:   'Cerrar con Carga Manual',
  },
  language: {
    es: 'Español',
    en: 'English',
  },
} as const;

export default es;
